import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { AgentAvatar } from './AgentAvatar';
import { MARKETPLACE } from '@/constants/testIds';

export const AgentCard = ({ agent }) => {
  return (
    <motion.div
      whileHover={{ y: -3 }}
      data-testid={MARKETPLACE.agentCard}
      className="card-base card-hover p-5 flex flex-col gap-4 h-full"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <AgentAvatar name={agent.name} size={44} />
          <div className="flex flex-col">
            <span className="display text-base font-semibold leading-tight">{agent.name}</span>
            <span className="text-xs text-white/55 leading-tight">{agent.role}</span>
          </div>
        </div>
        {agent.featured && (
          <span className="text-[10px] uppercase tracking-widest px-2 py-1 rounded-full border border-[#FF6B1A]/35 text-[#FFB17A] bg-[#FF6B1A]/10 flex items-center gap-1">
            <Sparkles className="h-3 w-3" /> Featured
          </span>
        )}
      </div>
      <p className="text-sm text-white/65 leading-relaxed line-clamp-3 min-h-[60px]">{agent.description}</p>
      <div className="flex flex-wrap gap-1.5">
        {(agent.tags || []).slice(0, 3).map((t) => (
          <span key={t} className="text-[10px] px-2 py-0.5 rounded-full border border-border/60 text-white/60 bg-white/3">
            #{t}
          </span>
        ))}
      </div>
      <div className="mt-auto pt-3 border-t border-border/60 flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-widest text-[#39FF14]">{agent.category}</span>
        <Link
          to={`/agents/${agent.agent_id}`}
          data-testid={MARKETPLACE.tryButton}
          className="btn-primary inline-flex items-center gap-1 rounded-lg px-3 py-1.5 text-xs font-medium"
        >
          Try Now <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </motion.div>
  );
};
